import store from '@/store/index.js'

import { Auth } from 'aws-amplify'
import Settings from '@/views/Settings/Settings'
import SettingsNoSelection from '@/views/Settings/SettingsNoSelection'
import CompanyDetails from '@/views/Settings/CompanyDetails/CompanyDetails'
import DriverFeedback from '@/views/Settings/DriverFeedback/DriverFeedback'
import Messages from '@/views/Settings/Messages/Messages'
import Messenger from '@/views/Settings/Messenger/Messenger'
import DropDowns from '@/views/Settings/DropDowns/DropDowns'
import UserIndex from '@/views/Settings/Users/UserIndex'
import UserForm from '@/views/Settings/Users/components/UserForm'
import OrgChart from '@/views/Settings/Users/OrgChart'
import RolesList from '@/views/Settings/Users/components/RolesList'
import InvoiceIndex from '@/views/Settings/Billing/InvoiceIndex'
import AccountDetails from '@/views/Settings/Accounts/AccountDetails'
import HeraAIIndex from '@/views/Settings/HeraAI/HeraAI'
import CustomLists from '@/views/Settings/CustomLists/CustomLists'
import VehiclePhotoLogs from '@/views/Settings/VehiclePhotoLogs/VehiclePhotoLogs'
import RosterChecklistIndex from '@/views/Settings/RosterChecklist/RosterChecklistIndex'
import RosterChecklistEditor from '@/views/Settings/RosterChecklist/components/RosterChecklistEditor'
import RosterChecklistsTableCard from '@/views/Settings/RosterChecklist/components/RosterChecklistsTableCard'
import Inventory from '@/views/Settings/Inventory/Inventory.vue'
import WirelessSupportSync from '@/views/Settings/WirelessSupportSync/WirelessSupportSync.vue'
import AssociateApp from '@/views/Settings/AssociateApp/AssociateApp'
import Error from '@/views/Settings/Error/Error'
import Alert from '@/views/Settings/Error/Alert'
import { isAllowedByRoute } from '@/middlewares/permissions'
import { isHierarchicalPermissionsEnabled } from '@/utilities/visibleStaffSet'

import Labels from '@/views/Settings/Labels/LabelsIndex'
import NotFound from '../views/System/NotFound'

var USER_PERMISSIONS =  process.env.VUE_APP_USER_PERMISSIONS === "1";

export default [
    {
      path: '',
      name: 'SettingsNoSelection',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: SettingsNoSelection
      }
    },
    {
      path: 'company',
      name: 'SettingsCompanyDetails',
      meta: { crumbTitle: 'Company Details'},
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: CompanyDetails
      }
    },
    {
      path: 'driver-feedback',
      name: 'SettingsThresholds',
      meta: { crumbTitle: 'Driver Feedback'},
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: DriverFeedback
      }
    },
    {
      path: 'messages',
      name: 'SettingsMessageLogs',
      meta: { crumbTitle: 'Messages'},
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Messages
      }
    },
    {
      path: 'messenger',
      name: 'SettingsMessenger',
      meta: { crumbTitle: 'Messenger'},
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Messenger
      }
    },
    {
      path: 'drop-downs',
      name: 'SettingsDropDowns',
      meta: { crumbTitle: 'Drop Down Lists'},
      beforeEnter: onlyAllowAdmin,
      props: true,
      components: {
        default: Settings,
        settings: DropDowns
      }
    },
    {
      path: 'users',
      name: 'SettingsUserIndex',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: UserIndex
      }
    },
    {
        path: 'users/detail/:id?',
        name: 'SettingsUserDetail',
        beforeEnter: onlyAllowAdmin,
        props: true,
        components: {
          default: Settings,
          settings: UserForm
        }
    },
    {
        path: 'users/roles',
        name: 'SettingsUserRoles',
        beforeEnter: onlyAllowAdmin,
        components: {
          default: Settings,
          settings: RolesList
        }
    },
    {
        path: 'users/org-chart',
        name: 'SettingsOrgChart',
        beforeEnter: async (to, from, next) => {
          if (!isHierarchicalPermissionsEnabled()) {
            return next('/settings/users')
          }
          await onlyAllowAdmin(to, from, next)
        },
        components: {
          default: Settings,
          settings: OrgChart
        }
    },
    {
      path: 'account-details',
      name: 'SettingsAccountDetails',
      beforeEnter: onlyAllowAdmin,
      props: true,
      components: {
        default: Settings,
        settings: AccountDetails
      }
    },
    {
      path: 'invoices',
      name: 'SettingsBilling',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: InvoiceIndex
      }
    },
    {
      path: 'hera-ai',
      name: 'SettingsHeraAIIndex',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: HeraAIIndex
      }
    },
    {
      path: 'custom-lists',
      name: 'SettingsCustomLists',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: CustomLists
      }
    },
    {
      path: 'vehicle-photo-logs',
      name: 'SettingsVehiclePhotoLog',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: VehiclePhotoLogs
      }
    },
    {
      path: 'roster-checklists',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: RosterChecklistsTableCard,
        settings: RosterChecklistIndex
      },
      children: [
        {
          path: '/',
          name: RosterChecklistsTableCard.name,
          beforeEnter: getChecklistComponent(RosterChecklistsTableCard)
        },
        {
          path: ':rosterChecklistId',
          name: RosterChecklistEditor.name,
          props: true,
          beforeEnter: getChecklistComponent(RosterChecklistEditor)
        },
      ]
    },
    {
      path: 'error',
      name: 'SettingsError',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Error
      }
    },
    {
      path: 'alert',
      name: 'SettingsAlert',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Alert
      }
    },
    {
      path: 'labels',
      name: 'SettingsLabels',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Labels
      }
    },
    {
      path: 'inventory',
      name: 'Inventory',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: Inventory
      }
    },
    {
      path: 'wireless-support-sync',
      name: 'WirelessSupportSync',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: WirelessSupportSync
      }
    },
    {
      path: 'associate-app',
      name: 'SettingsAssociateApp',
      beforeEnter: onlyAllowAdmin,
      components: {
        default: Settings,
        settings: AssociateApp
      }
    }
  ]


  async function onlyAllowSystemAdmin(to, from, next){
    window.scrollTo(0, 0);
    const groups = await getGroups()
    if(!groups.includes("system_admin")){
      next({
        path: from.path,
        query: { error: "You Don't Have Access To This Area" }
      })
    }else{
      next()
    }
  }

  async function onlyAllowAdmin(to, from, next){
    window.scrollTo(0, 0);
    const groups = await getGroups()
    if(!USER_PERMISSIONS && (!groups.includes("system_admin") && !groups.includes("admin") && !store.state.userInfo.role.includes("admin"))){
      next({
        path: from.path,
        query: { error: "You Don't Have Access To This Area" }
      })
    }else if(USER_PERMISSIONS) {
      try {

        let isAllowed = await isAllowedByRoute(store.state.userInfo.id, store.state.userInfo.group, to.path)

        if(!isAllowed) {
          next({
            path: '/settings/alert'
          })
        } else {
          next()
        }
      } catch(e) {

        await Auth.signOut()
        next({
          path: '/',
          query: { error: "Please contact your administrator for access to these settings" }
        })
      }
    }else{
      next()
    }
  }

  function getChecklistComponent(component){
    return async function(to, from, next){
      if(store.state.userInfo?.tenant?.featureAccessRosterChecklist){
        const matched = to.matched.find((match) => match.name === component.name)
        matched.components.default = component
      }else{
        to.matched[0].components.default = NotFound
      }
      await onlyAllowAdmin(to, from, next)
    }
  }

  function getGroups () {
    return new Promise((resolve, reject) => {
      if (store.getters.groups === undefined) {
        const unwatch = store.watch(
          () => store.getters.groups,
          (value) => {
            unwatch()
            resolve(value)
          }
        )
      } else {
        resolve(store.getters.groups)
      }
    })
  }
